export { default } from './ContactInfo';
export type { Company, ContactInfoProps } from './ContactInfo';
